import { render, staticRenderFns } from "./CmgFacPill.vue?vue&type=template&id=d4485fb8&scoped=true&lang=pug"
import script from "./cmg-fac-pill.ts?vue&type=script&lang=ts&external"
export * from "./cmg-fac-pill.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgFacPill.vue?vue&type=style&index=0&id=d4485fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4485fb8",
  null
  
)

export default component.exports